import { Col, Row } from "taltech-styleguide";
import { useWizard } from "../../wizard/context";
import { ProgressWizardStepForm } from "../../wizard/ProgressWizardStepForm";
import { StepState, WizardStep } from "../../wizard.types";
import { useParams } from "react-router-dom";
import { FC } from "react";
import { LayoutReview } from "./LayoutReview";

export const creationTypeMapper: Map<string | number, string> = new Map();
creationTypeMapper.set("RANDOM", "Random");
creationTypeMapper.set(0, "Random");
creationTypeMapper.set("CONSTANT", "Constant");
creationTypeMapper.set(1, "Constant");

export const MinMaxComponent: FC<{
  min: number;
  max: number;
  suffix?: string;
}> = ({ min, max, suffix = "" }) => (
  <p>
    <b className="ms-2 me-1">Min:</b>
    {min + suffix}
    <b className="ms-2 me-1">Max:</b>
    {max + suffix}
  </p>
);

export const ReviewConfigurationContent: FC<any> = ({
  info,
  layout,
  elements,
}) => {
  return (
    <div className="d-flex flex-wrap">
      <Col sm="12" md="6" className="left">
        <div id="step1">
          <h5>Information</h5>
          <p>
            <b className="me-2">Building Name:</b>
            {info.name}
          </p>
          <p>
            <b className="me-2">Building Description:</b>
            {info.description}
          </p>
          <p>
            <b className="me-2">Building Orientation:</b>
            {creationTypeMapper.get(info.rotation.angle.creationType) ===
            "Random" ? (
              <MinMaxComponent
                {...{ ...info.rotation.angle.options, suffix: "º" }}
              />
            ) : (
              info.rotation.angle.value
            )}
          </p>
          <p>
            <b className="me-2">Building Height Type:</b>
            {info.height.type === "FLOOR"
              ? "Number of floors, floor height"
              : "Building height, number of floors"}
          </p>
          <p>
            <b className="me-2">
              {info.height.type === "FLOOR"
                ? "Number of floors"
                : "Total height"}
              :
            </b>
            {`${info.numberOfLevels}${info.height.type === "FLOOR" ? "" : "m"}`}
          </p>
          <p>
            <b className="me-2">
              {info.height.type === "FLOOR"
                ? "Floor height"
                : "Number of floors"}
              :
            </b>
            {creationTypeMapper.get(info.height.value.creationType) ===
            "Random" ? (
              <MinMaxComponent
                {...{
                  ...info.height.value.options,
                  suffix: info.height.type === "FLOOR" ? "m" : "",
                }}
              />
            ) : (
              info.height.value.value
            )}
          </p>
        </div>
        <div id="step3">
          <h5>Components</h5>
          <p>
            <b className="me-2">Wall Interior:</b>
            {creationTypeMapper.get(elements.wallInterior.creationType)}
          </p>
          <p>
            <b className="me-2">Wall Exterior:</b>
            {creationTypeMapper.get(elements.wallExterior.creationType)}
          </p>
          <p>
            <b className="me-2">Floor:</b>
            {creationTypeMapper.get(elements.floor.creationType)}
          </p>
          <p>
            <b className="me-2">Floor Ground:</b>
            {creationTypeMapper.get(elements.floorGround.creationType)}
          </p>
          <p>
            <b className="me-2">Roof:</b>
            {creationTypeMapper.get(elements.roof.creationType)}
          </p>
          <p>
            <b className="me-2">Window Type:</b>
            {creationTypeMapper.get(elements.windowType.creationType)}
          </p>
        </div>
      </Col>
      <Col md="6" className="right">
        <div id="step2" className="w-100">
          <h5>Layout</h5>
          <LayoutReview {...layout} />
        </div>
      </Col>
    </div>
  );
};

export const ReviewConfiguration = ({ ...props }) => {
  const { buildingConfigId } = useParams();
  const { state } = useWizard();
  const { title, element, schema } = props;
  const info =
    buildingConfigId === undefined
      ? state.steps.find((x: any) => x.index === 0)!.data
      : {};
  const layout =
    buildingConfigId === undefined
      ? state.steps.find((x: any) => x.index === 1)!.data
      : {};
  const elements =
    buildingConfigId === undefined
      ? state.steps.find((x: any) => x.index === 2)!.data
      : {};
  const step4 = state.steps.find((x: any) => x.index === 3);

  return (
    <ProgressWizardStepForm element={element} title={title} schema={{}}>
      <ReviewConfigurationContent info={info} layout={layout} elements={elements} />
      {/* <div id="step4">
        <h5>4. {step4?.titleShort}</h5>
      </div> */}
    </ProgressWizardStepForm>
  );
};
